import { render } from "./RightSectionContainer.vue?vue&type=template&id=376a1396"
import script from "./RightSectionContainer.vue?vue&type=script&lang=js"
export * from "./RightSectionContainer.vue?vue&type=script&lang=js"

import "./RightSectionContainer.vue?vue&type=style&index=0&id=376a1396&lang=css"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__